// extracted by mini-css-extract-plugin
export var addToCartButton = "_pv-b";
export var arrowButtonContainer = "_pv-9";
export var arrowButtonIcon = "_pv-a";
export var carouselArrowButton = "_pv-6";
export var carouselElementContainer = "_pv-1";
export var galleryThumbnail = "_pv-d";
export var galleryThumbnailImage = "_pv-e";
export var left = "_pv-7";
export var productDisplayCarouselContainer = "_pv-0";
export var productTileContainer = "_pv-2";
export var productTileImage = "_pv-4";
export var productTileImageContainer = "_pv-3";
export var productTileTitle = "_pv-5";
export var right = "_pv-8";
export var sliderOverflow = "_pv-c";